/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    function initializeHomepageTiles() {
        var listings = '',
        collections = [
            {
                url: '/collections/playtime',
                name: 'Playtime',
                img: 'w43_playtime.webp'
            },
            {
                url: '/collections/nursery',
                name: 'Nursery',
                img: 'w43_nursery.webp'
            },
            {
                url: '/collections/baby-cot-online',
                name: 'Cots & Bassinets',
                img: 'w43_cot.webp'
            },
            {
                url: '/collections/baby-play-gym-toys-online',
                name: 'Play Mats & Gyms',
                img: 'w43_play_mats.webp'
            },
            {
                url: '/collections/baby-nursing-feeding',
                name: 'Nursing & feeding',
                img: 'w43_feeding.webp'
            },
            {
                url: '/collections/baby-clothes',
                name: 'Baby Clothes',
                img: 'w43_clothes.webp'
            },
            {
                url: '/collections/bath',
                name: 'Bath & Baby care',
                img: 'w43_bath_care.webp'
            },
            {
                url: '/collections/best-baby-tableware',
                name: 'Tableware',
                img: 'w43_tableware.webp'
            },
            {
                url: '/collections/baby-prams-online',
                name: 'Prams',
                img: 'w43_prams.webp'
            },
            {
                url: '/collections/play-time-plush-toy',
                name: 'Plush Toys',
                img: 'w43_plush_toys.webp'
            },
            {
                url: '/collections/baby-travel-pram',
                name: 'Travel Prams',
                img: 'w43_travel_prams.webp'
            },
            {
                url: '/collections/nursery-change-table-accessories',
                name: 'Change Tables & Accessories',
                img: 'w43_change_tables.webp'
            },
            {
                url: '/collections/wooden-toys',
                name: 'Wooden Toys',
                img: 'w43_wooden_toys.webp'
            },
            {
                url: '/collections/nursery-nursery-decor',
                name: 'Nursery Decor',
                img: 'w43_nursery_decor.webp'
            },
            {
                url: '/collections/single-pram',
                name: 'Single Prams',
                img: 'w43_single_pram.webp'
            },
            {
                url: '/collections/newborn-baby-swaddle-blankets',
                name: 'Swaddles & Blankets',
                img: 'w43_swaddles.webp'
            }
        ];
        

        document.documentElement.classList.add('w43');
        var collection, i, c;
        for (i = 0, c = collections.length; i < c; i++) {
            collection = collections[i];
            var listing = '<div class="grid__item collection small--one-half medium-up--one-quarter item-' + (i + 1) + '">\
                <a href="' + collection.url + '" class="collection-tile">\
                    <img src="https://cdn.shopify.com/s/files/1/0256/1471/2913/files/' + collection.img + '">\
                    <div class="title">' + collection.name + '</div>\
                </a>\
            </div>';
            listings += listing;
        }

        var container = document.querySelector('.grid--uniform');
        container.innerHTML = listings;

        var seeMore = document.createElement('div');
        seeMore.className = 'see-more';
        seeMore.innerHTML = '<a href="#" class="btn">SEE MORE</a>';
        container.insertAdjacentElement('afterend', seeMore);
        seeMore.children[0].addEventListener('click', function (e) {
            e.preventDefault();
            container.classList.add('show-more');
            seeMore.style.display = 'none';
        });
    }

    function triggerHomepageTiles() {
        if (location.pathname === '/') {
            Mojito.utils.domReady(initializeHomepageTiles);
        }
    }

    triggerHomepageTiles();
})();
